import React from "react";
import { getActivityFeed_activityFeed as ActivityFeed } from "types/gql-types";
import "./activity-email.css";

const styles = {
  bold: {
    fontWeight: 800,
    WebkitFontSmoothing: "antialiased",
    color: "#494848",
  },
  visibleWrapper: {
    marginBottom: 20,
  },
};

const MessagePreviewFeedItem:React.FC<{
  activity: ActivityFeed;
}> = ({ activity }) => {
  const [isHidden, setIsHidden] = React.useState(true);

  const togglePreview:React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    event.preventDefault();
    setIsHidden(!isHidden);
  };

  const { metadata } = activity;
  return (
    <div>
      {metadata?.emailSubject && (
        <div>
          <span style={styles.bold}>Subject:</span> {metadata?.emailSubject} <br />
        </div>
      )}
      {isHidden ? (
        <a href="#" onClick={togglePreview}>
            Preview Message Body
        </a>
      ) : (
        <div style={styles.visibleWrapper}>
          <div className="email-container">
            <span dangerouslySetInnerHTML={{ __html: metadata?.body ?? "" }} />
          </div>
          <a href="#" onClick={togglePreview}>
              Close Preview
          </a>
        </div>
      )}
    </div>
  );
};

export default MessagePreviewFeedItem;
